/* Extracted from snippets/cro-longer-delivery-banner.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(function () {
    var banner = document.querySelector('[data-longer-delivery-banner]');
    if (!banner) return;
    var btn = banner.querySelector('.cro-ld-banner__toggle');
    var detail = document.getElementById('cro-ld-banner-detail');
    if (!btn || !detail) return;
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      detail.hidden = expanded;
    });
  })();
